import {
  registerDemoActiveCasesSource,
  registerDemoTrackingSource,
} from '#entities';

/** Dynamic: a static import pulls the demo payload into the main chunk. */
export const registerDemoCaseSources = (): void => {
  registerDemoActiveCasesSource(() =>
    import('#entities/DemoCase').then(m => m.buildDemoActiveCases),
  );
  registerDemoTrackingSource(() =>
    import('#entities/DemoCase').then(m => m.buildDemoTracking),
  );
};
